export enum OverviewBudgetChartEnum {
    BUDGET = 'budget-chart',
    BILL = 'bill-chart'
}
